// extracted by mini-css-extract-plugin
export var container = "_bm-0";